import { render } from "./ModalCentral.vue?vue&type=template&id=a81597be&scoped=true"
import script from "./ModalCentral.vue?vue&type=script&lang=js"
export * from "./ModalCentral.vue?vue&type=script&lang=js"

import "./ModalCentral.vue?vue&type=style&index=0&id=a81597be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a81597be"]])

export default __exports__